<template>
    <div>
        <b-form-group
            v-for="question in questions"
            :key="question.id"
            class="dark-text m-0 pt-2"
        >
            <humor-question :question="question" :update="update" />
        </b-form-group>
    </div>
</template>

<script>
import HumorQuestion from './components/humor'

export default {
    components: { HumorQuestion },
    props: {
        questions: {
            required: true,
        },
        update: {
            type: Function,
            required: true,
        },
    },
}
</script>

<style scoped>
.dark-text {
    color: #3b3f4e;
}
</style>
